import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'publisher/reducers/filesReducer'

export { selectors }

export default function useFiles(selector) {
  return useSelector(state => selector(state.files), shallowEqual)
}
